var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667C10.8333 15.0507 11.1844 15.8986 11.8096 16.5237C12.4347 17.1488 13.2825 17.5 14.1666 17.5C15.0506 17.5 15.8985 17.1488 16.5236 16.5237C17.1487 15.8986 17.4999 15.0507 17.4999 14.1667C17.4999 13.2826 17.1487 12.4348 16.5236 11.8097C15.8985 11.1845 15.0506 10.8333 14.1666 10.8333C13.2825 10.8333 12.4347 11.1845 11.8096 11.8097C11.1844 12.4348 10.8333 13.2826 10.8333 14.1667Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 10.8333V14.1667H17.5001",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5V5.83333C10 6.05435 10.0878 6.26631 10.2441 6.42259C10.4004 6.57887 10.6123 6.66667 10.8333 6.66667H14.1667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H10L14.1667 6.66667V8.33333M14.1667 10.8333V14.1667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#3A4752"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightReportsIcon);
export default __webpack_public_path__ + "static/media/light-reports-icon.aee2432d7223b7a4af2e46c930c4dd13.svg";
export { ForwardRef as ReactComponent };